<template>
    <div class="ntitle">
        <div class="left-name YouSheBiaoTiHei2" @click="goLink">
            <slot></slot>
            <!-- <img class="icon" src="@/assets/newscreen/icon_arrow.png" alt=""> -->
        </div>
        <slot name="control"></slot>
    </div>
</template>

<script>
export default {
    props: ["link"],
    methods: {
        goLink() {
            // this.$router.push(this.link);
        }   
    }
}
</script>

<style lang="scss" scoped>
.ntitle {
    width: 100%;
    height: 2.5rem;
    background: url(../../assets/newscreen/bg_title_1.png) no-repeat;
    background-size: 100% 100%;
    text-align: left;
    line-height: 2.5rem;

    font-size: 1.2rem;
    color: #F5FAFF;
    letter-spacing: 0;
    // text-shadow: 0 2px 4px #44D7B6;
    // font-weight: 600;
    display: flex;
    justify-content: space-between;
    .left-name {
        padding-left: 3rem;
        display: flex;
        align-items: center;
        // cursor: pointer;
        // &:hover {
        //     text-shadow: 0 5px 10px #44D7B6;
        // }
    }
    .icon {
        width: 1rem;
        margin-left: 0.5rem;
    }
}
</style>